export default function maybeIOS(deviceInfo) {
  const touchDevice =
    typeof document !== "undefined" && "ontouchend" in document;
  //この関数はSSRしないページで呼ばれることは現在ないが、一応deviceInfoの参照にオプショナルをつけておく
  return (touchDevice && deviceInfo?.isMac) || deviceInfo?.isIOS;
}
